import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { Col, Row, Button, Alert, Spinner, Tabs, Tab } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import API from "../Utility";
import Moment from "react-moment";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import WorkflowUsers from './WorkflowUsers';
import WorkflowOverview from './WorkflowOverview';
import WorkflowTasks from './WorkflowTasks';

// Styles
import "./WorkflowView.scss";

export default function WorkflowView({ children, ...routeProps }) {
  let { project, workflowId } = useParams();
  let history = useHistory();
  const location = useLocation();
  let stateWorkflow = location && location.state ? location.state.workflow : {};
  let { action } = routeProps;
  if (!action) {
    action = 'update';
  }

  const [formMode, setFormMode] = useState(action); // create or update handled here
  const [workflowName, setWorkflowName] = useState();

  const [workflow, setWorkflow] = useState(stateWorkflow);
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [refreshUsers, setRefreshUsers] = useState(false);
  const [refreshTasks, setRefreshTasks] = useState(false);
  const [refreshWorkflow, setRefreshWorkflow] = useState(false);
  const [currentWorkflowId, setCurrentWorkflowId] = useState();
  const [errorMessage, setErrorMessage] = useState(null);


  async function getWorkflowData(query) {
    try {
      setIsLoading(true);
      let apiWorkflow = await API.get({
        url: query.url,
      });
      if (apiWorkflow === undefined) {
        setIsLoading(false);
        setErrorMessage('Your session has expired or you are signed in on a different device. Please log in again.');
      }
      setIsLoading(false);
      return apiWorkflow;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    async function initializeData() {
      let apiWorkflow = await getWorkflowData({
        url: `/admin/${project}/workflows/${workflowId}`,
      });

      setWorkflow(apiWorkflow);
      setWorkflowName(apiWorkflow?.name);
      setItems(apiWorkflow?.milestones);
      setCurrentWorkflowId(apiWorkflow?._id);
      setRefreshWorkflow(false);
    }
    if ((action && action === "update" && !workflow?._id) || workflowId !== currentWorkflowId || refreshWorkflow) {
      initializeData();
    } else {
      setWorkflowName(workflow.name);
      setItems(workflow?.milestones);
    }
  }, [workflowId, refreshWorkflow]);

  const loading = () => {
    return (!workflow?._id || workflowId !== currentWorkflowId) && isLoading ? (
      <div>
        <Spinner animation="border" />
      </div>
    ) : (
      <div>
        <span>{errorMessage ? errorMessage : 'Workflow not found'}</span>
      </div>
    );
  };

  const onMilestonesChange = (milestones) => {
    setItems(milestones);
  };

  useEffect(() => {
    onMilestonesChange(items);
  }, [items]);

  if ((action && action === "update" && !workflow?._id) || workflowId !== currentWorkflowId) {
    return (
      <React.Fragment>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'center', justifyContent: 'center' }}>
          {loading()}
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="workflow-view">
      <div>
        <Row>
          <Col>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'row', flex: 2, justifyContent: 'space-between', alignItems: 'baseline', marginRight: '106px' }}>
                <div style={{ display: 'flex', flexDirection: 'row', fontSize: '30px', alignItems: 'center' }}>
                  <LinkContainer to={`/workflows/${project}`}>
                    <div className='clickable'><b>Workflows</b></div>
                  </LinkContainer>
                  <div style={{ padding: '0 10px' }}>
                    <ArrowForwardIosIcon style={{ fontSize: '25px' }} />
                  </div>
                  <LinkContainer
                    to={
                      formMode === "create"
                        ? `workflows/${project}`
                        : `/workflows/${project}/${workflowId}`
                    }
                  >
                    <div><b>{formMode === "create" ? "New Workflow" : workflowName}</b></div>
                  </LinkContainer>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}></div>
            </div>
            <br /><br />
          </Col>
        </Row>
      </div>
      <Tabs
        defaultActiveKey={'workflow'}
        id={'workflow-tabs'} >
        <Tab eventKey={'workflow'} title={'Workflow'}>
          <WorkflowOverview workflow={workflow} setRefreshUsers={(val) => setRefreshUsers(val)} setRefreshTasks={(val) => setRefreshTasks(val)} />
        </Tab>
        <Tab eventKey={'overview'} title={'Overview'}>
          <WorkflowUsers workflow={workflow} refreshUsers={refreshUsers} setRefreshUsers={(val) => setRefreshUsers(val)} refreshTasks={refreshTasks} setRefreshTasks={(val) => setRefreshTasks(val)} setRefreshWorkflow={setRefreshWorkflow} />
        </Tab>
        <Tab eventKey={'outstanding'} title={'Outstanding'}>
          <WorkflowTasks workflow={workflow} refreshUsers={refreshUsers} setRefreshUsers={(val) => setRefreshUsers(val)} refreshTasks={refreshTasks} setRefreshTasks={(val) => setRefreshTasks(val)} />
        </Tab>
      </Tabs>
    </div >
  );
}